import { DatumObject } from '@visx/shape/lib/types';
import { Tooltip } from '@visx/xychart';

import { Card } from '../../card/card';
import { BaseChartProps } from '../charts.model';
import { formatDate, startCase } from '../common/formatters';

import { DefaultTooltip } from './default-tooltip';

interface ChartTooltipProps<T extends DatumObject> extends BaseChartProps<T> {
    dateKey: keyof T;
    glyphs?: boolean;
    crosshair?: boolean;
    snapX?: boolean;
    snapY?: boolean;
}

const crosshairStyle = { stroke: 'var(--color-content-muted)', strokeWidth: 0.25, strokeDasharray: '2' };

export const ChartTooltip = <T extends DatumObject = DatumObject>({
    dateKey,
    formatX = formatDate,
    formatY,
    formatLabel = startCase,
    crosshair = false,
    glyphs = false,
    snapX = true,
    snapY,
    renderTooltip: TooltipComponent = DefaultTooltip,
}: ChartTooltipProps<T>) => (
    <Tooltip<T>
        snapTooltipToDatumX={snapX}
        snapTooltipToDatumY={snapY}
        showVerticalCrosshair={crosshair}
        showHorizontalCrosshair={crosshair}
        showSeriesGlyphs={glyphs}
        verticalCrosshairStyle={crosshairStyle}
        horizontalCrosshairStyle={crosshairStyle}
        renderTooltip={({ tooltipData, colorScale }) => {
            if (!tooltipData?.nearestDatum?.datum) return null;
            const {
                nearestDatum: { key: dataKey, datum },
                datumByKey,
            } = tooltipData;
            const props = {
                datum,
                datumByKey,
                dateKey: String(dateKey),
                dataKey,
                colorScale,
                formatX,
                formatY,
                formatLabel,
            };

            return (
                <Card>
                    <TooltipComponent {...props} />
                </Card>
            );
        }}
    />
);
